import { createMessageUseCase } from '@src/main/modules/messages/application/use-cases/create/create-message.usecase';
import { CreateMessageRequest } from '@src/main/modules/messages/infrastructure/dto/createMessageRequest';
import { createOutboxMessageHttpRepository } from '@src/main/modules/messages/infrastructure/repository/OutboxMessageHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useCreateMessage = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createOutboxMessageHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (data: CreateMessageRequest) => {
      if (!repository) throw new Error('Repository not initialized');
      return await createMessageUseCase(data, tokenProvider);
    },
  });
};
